const EmsMenu = [
    {
        icon: "crisis_alert",
        key: "configuration.nms-alert-history",
        name: "Nms-Alert-History",
        url: "home/app/configurations/nms-alert-history",
        description: "Nms-Alert-History",
        productionReady: true,
        disabled: false,
      },
      {
        icon: "schedule_send_icon",
        key: "escalationDetails",
        name: "Escalation Details",
        description: "Escalation Details",
        url: "home/app/escalation-details",
        disabled: false,
        productionReady: true,
      },
  ];
  
  export { EmsMenu };